import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-593a4834"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "change-user-data-form" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { class: "label" }
const _hoisted_4 = { class: "v-message" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "label" }
const _hoisted_7 = { class: "v-message" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { class: "v-message" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "label" }
const _hoisted_13 = { class: "v-message" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "label" }
const _hoisted_16 = { class: "v-message" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { class: "label" }
const _hoisted_19 = { class: "v-message" }
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = { class: "label" }
const _hoisted_22 = { class: "v-message" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = { class: "label" }
const _hoisted_25 = { class: "v-message" }
const _hoisted_26 = { class: "form-group" }
const _hoisted_27 = { class: "label" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Spara Uppgifter")
const _hoisted_29 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_field = _resolveComponent("v-field")!
  const _component_v_message = _resolveComponent("v-message")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_form, { onSubmit: _ctx.onSubmit }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("Common.Name")), 1),
          _createVNode(_component_v_field, {
            name: "name",
            type: "text",
            class: "input form-control",
            modelValue: _ctx.customer.firstName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.customer.firstName) = $event)),
            rules: "required",
            readonly: ""
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_v_message, { name: "name" })
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("Common.LastName")), 1),
          _createVNode(_component_v_field, {
            name: "lastName",
            type: "text",
            class: "input form-control",
            modelValue: _ctx.customer.lastName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.customer.lastName) = $event)),
            rules: "required",
            readonly: ""
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_v_message, { name: "lastName" })
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("Common.EmailAddress")), 1),
          _createVNode(_component_v_field, {
            name: "email",
            type: "email",
            class: "input form-control",
            modelValue: _ctx.customer.email,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.customer.email) = $event)),
            rules: "required|email",
            readonly: ""
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_v_message, { name: "email" })
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("Common.Address1")), 1),
          _createVNode(_component_v_field, {
            name: "line1",
            type: "text",
            class: "input form-control",
            modelValue: _ctx.updateModel.line1,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.updateModel.line1) = $event)),
            rules: "required"
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_v_message, { name: "line1" })
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("Common.ZipCode")), 1),
          _createVNode(_component_v_field, {
            name: "zip",
            type: "text",
            class: "input form-control",
            modelValue: _ctx.updateModel.zip,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.updateModel.zip) = $event)),
            rules: "required"
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_v_message, { name: "zip" })
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("Common.City")), 1),
          _createVNode(_component_v_field, {
            name: "city",
            type: "text",
            class: "input form-control",
            modelValue: _ctx.updateModel.city,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.updateModel.city) = $event)),
            rules: "required"
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_v_message, { name: "city" })
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t("Common.Country")), 1),
          _createVNode(_component_v_field, {
            name: "country",
            type: "text",
            class: "input form-control",
            modelValue: _ctx.updateModel.country,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.updateModel.country) = $event)),
            rules: "required"
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_v_message, { name: "country" })
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("Common.MobilePhone")), 1),
          _createVNode(_component_v_field, {
            name: "mobilePhone",
            type: "tel",
            class: "input form-control",
            modelValue: _ctx.updateModel.mobilePhone,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.updateModel.mobilePhone) = $event)),
            rules: _ctx.validatePhone
          }, null, 8, ["modelValue", "rules"]),
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_v_message, { name: "mobilePhone" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Phone.NotValid')), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t("Common.Message")), 1),
          _createVNode(_component_v_field, {
            name: "deliveryInformation",
            type: "text",
            class: "input form-control",
            modelValue: _ctx.updateModel.deliveryInformation,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.updateModel.deliveryInformation) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createVNode(_component_BaseButton, {
          class: "btn btn-dark",
          type: "submit"
        }, {
          default: _withCtx(() => [
            _hoisted_28
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onSubmit"]),
    (_ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: "mt-2",
          innerHTML: _ctx.errorMessage
        }, null, 8, _hoisted_29))
      : _createCommentVNode("", true)
  ]))
}